/**
 * Copy text to clipboard.
 * @param {string} text
 * @param {{ silent?: boolean }} [options] - silent: do not console.log the value (use for secrets)
 */
const copyToClipboard = (text, options = {}) => {
    if (!text) return Promise.resolve(false);
    const silent = !!options.silent;
    return navigator.clipboard
        .writeText(text)
        .then(() => {
            if (!silent) {
                console.log('clipboard ->' + text);
            }
            return true;
        })
        .catch((err) => {
            console.error('Failed to copy text: ', err);
            return false;
        });
};

export default copyToClipboard;
